import {NOT_STARTED} from '../constants/index';
import moment from 'moment';
import 'moment/locale/de';

const LOCALE = 'de';
const UNKNOWN_LABEL = 'Unbekanntes Datum';

const toMoment = (v) => {
	if (!v) return null;
	if (moment.isMoment(v)) return v.locale(LOCALE);

	let m = moment(v, moment.ISO_8601, true);
	if (!m.isValid()) m = moment(v);
	return m.isValid() ? m.locale(LOCALE) : null;
};

const pickMoment = (row) =>
	toMoment(row.distributedAt) ||
	toMoment(row.usedAt) ||
	toMoment(row.completedAt) ||
	toMoment(row.createdAt);

export const getBestTestResultMoment = (testResult) => {
	const {createdAt, distributedAt, usedAt, completedAt} = testResult;
	if (completedAt) {
		return completedAt;
	}

	if (usedAt) {
		return usedAt;
	}

	if (distributedAt) {
		return distributedAt;
	}

	if (createdAt) {
		return createdAt;
	}

	throw new Error(`No valid moment for testResult with id ${testResult.id}`);
};

export default function getCategorisedTests(rows = []) {
	const undistributed = [];
	const rest = [];

	for (const row of rows) {
		const isUndistributed =
			row.status === NOT_STARTED ||
			(!row.distributedAt && !row.usedAt && !row.completedAt);
		(isUndistributed ? undistributed : rest).push(row);
	}

	undistributed.sort((a, b) => {
		const at = (pickMoment(a) || moment(0)).valueOf();
		const bt = (pickMoment(b) || moment(0)).valueOf();
		return bt - at;
	});

	const monthMap = new Map();
	for (const row of rest) {
		const m = pickMoment(row);
		const key = m ? m.format('YYYY-MM') : 'unknown';
		const name = m ? m.locale('nb').format('MMMM YYYY') : UNKNOWN_LABEL;

		let bucket = monthMap.get(key);
		if (!bucket) {
			bucket = {key, name, testResults: []};
			monthMap.set(key, bucket);
		}
		bucket.testResults.push(row);
	}

	const months = Array.from(monthMap.values()).sort((a, b) => {
		if (a.key === 'unknown') return 1;
		if (b.key === 'unknown') return -1;
		return a.key > b.key ? -1 : 1;
	});

	months.forEach((bucket) => {
		bucket.testResults.sort((a, b) => {
			const at = (pickMoment(a) || moment(0)).valueOf();
			const bt = (pickMoment(b) || moment(0)).valueOf();
			return bt - at;
		});
	});

	const result = [];
	if (undistributed.length) {
		result.push({
			key: 'undistributed',
			name: 'nicht gestartete Tests',
			testResults: undistributed,
		});
	}
	result.push(...months);

	return result;
}
